import { useHttp } from '@/shared/api/provider';

import type { IBookingDoctorData } from '@/entities/booking/model/types';
import type { IMedcenter } from '@/entities/medcenter/model/types';

interface UseFetchBookingDataProps {
  medcenters: IMedcenter[];
  doctorAlias: string;
}

interface UseFetchBookingDataReturn {
  fetchBookingData: (medcenterId: number | null) => Promise<IBookingDoctorData[]>;
}

/**
 * Хук для получения данных бронирования врача
 *
 * @param props - Параметры хука
 * @param props.medcenters - Массив медицинских центров
 * @param props.doctorAlias - Алиас врача для получения данных бронирования
 *
 * @returns Объект с функцией fetchBookingData для получения данных бронирования
 */
export const useFetchBookingData = ({
  medcenters,
  doctorAlias,
}: UseFetchBookingDataProps): UseFetchBookingDataReturn => {
  const repositories = useHttp();

  const fetchBookingData = async (medcenterId: number | null): Promise<IBookingDoctorData[]> => {
    let data: IBookingDoctorData[] = [];

    const hasOnlineBooking = medcenters.some(medcenter => medcenter.hasOnlineBooking);
    const shouldFetchBookingData = !medcenterId || medcenters.some(medcenter => medcenter.id === medcenterId);

    if (hasOnlineBooking && shouldFetchBookingData) {
      data = await repositories.doctor.getBookingDataDoctorByAlias(doctorAlias);
    }

    return data;
  };

  return { fetchBookingData };
};
